import { ChangeEvent, FormEvent, FunctionComponent, useState } from 'react';

import { getErrorsFromRequest } from 'utils/api';

import { create as contactFormRequest } from 'requests/contactFormQuery';

import Button from 'components/layout/Button';
import { ButtonTypes } from 'components/layout/Button/types';
import Form from 'components/layout/forms/Form';
import Input from 'components/layout/forms/Input';
import InputRow from 'components/layout/forms/InputRow';
import TextArea from 'components/layout/forms/TextArea';

import StyledComponent from './styles';
import { Props } from './types';

interface HandleValue {
    [key: string]: string | number;
}

interface FormState {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    content: string;
}

interface Errors extends FormState { };

const ContactForm: FunctionComponent<Props> = ({ translations, onSuccess }) => {
    const [formValues, setFormValues]: [FormState, Function] = useState(null);
    const [errorMessage, setErrorMessage]: [Errors, Function] = useState(null);

    const submitForm = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        contactFormRequest({ ...formValues })
            .then(() => onSuccess && onSuccess())
            .catch((errors) => setErrorMessage(getErrorsFromRequest(errors)));
    };

    const handleChange = (value: HandleValue) => setFormValues((prevState: FormState) => ({ ...prevState, ...value }));

    return (
        <StyledComponent className="content-section-company-register">
            <Form
                onSubmit={submitForm}
                className="register-form"
            >
                <h2 className="title title-margin">{translations?.titlePerson}</h2>
                <InputRow>
                    <Input
                        name='firstName'
                        label={translations?.inputFirstName}
                        placeholder={translations?.inputFirstName}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange({ firstName: e.target.value })}
                        value={formValues?.firstName}
                        error={errorMessage?.firstName}
                    />
                    <Input
                        name='lastName'
                        label={translations?.inputLastName}
                        placeholder={translations?.inputLastName}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange({ lastName: e.target.value })}
                        value={formValues?.lastName}
                        error={errorMessage?.lastName}
                    />
                </InputRow>
                <Input
                    name='email'
                    label={translations?.inputEmail}
                    placeholder={translations?.inputEmail}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange({ email: e.target.value })}
                    value={formValues?.email}
                    error={errorMessage?.email}
                />
                <Input
                    name='phone'
                    label={translations?.inputPhone}
                    placeholder={translations?.inputPhone}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange({ phone: e.target.value })}
                    value={formValues?.phone}
                    error={errorMessage?.phone}
                />
                <h2 className="title">{translations?.titleMessage}</h2>
                <TextArea
                    name='message'
                    label={translations?.inputMessage}
                    placeholder={translations?.inputMessage}
                    onChange={(e: ChangeEvent<HTMLTextAreaElement>) => handleChange({ content: e.target.value })}
                    value={formValues?.content}
                    error={errorMessage?.content}
                />
                <Button
                    className="submit-button"
                    type={ButtonTypes.Submit}
                >
                    {translations?.submitButton}
                </Button>
            </Form>
        </StyledComponent>
    );
};

export default ContactForm;
